import { render, staticRenderFns } from "./ChoosePlanButton.vue?vue&type=template&id=ab3b11be&scoped=true&"
import script from "./ChoosePlanButton.vue?vue&type=script&lang=ts&"
export * from "./ChoosePlanButton.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePlanButton.vue?vue&type=style&index=0&id=ab3b11be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3b11be",
  null
  
)

export default component.exports